export enum IconTypes {
  Edit = 'Edit',
  Trash = 'Trash',
  MoveUp = 'MoveUp',
  MoveDown = 'MoveDown',
  GuideAddIcon = 'GuideAddIcon',
  RobotIconSolid = 'RobotIconSolid',
  ArrowDownTrayIcon = 'ArrowDownTrayIcon',
  Reload = 'Reload',
  PlusIcon = 'PlusIcon',
  Refresh = 'ArrowPathIcon',
  Reading = 'Reading',
  Summary = 'Summary',
  FullScreenIcon = 'FullScreenIcon',
  ArrowsPointingOutIcon = 'ArrowsPointingOutIcon',
  Clipboard = 'Clipboard',
}
